export default function scrollToTop() {
	document.getElementById('go-to-top').addEventListener("click", function (event) {
		event.preventDefault();
		gsap.to(window, { duration: 1, scrollTo: 0 });
	});
}